import {
  GET_CIVILBUDGET,
  GET_CIVILBUDGET_SUCCESS,
  GET_CIVILBUDGET_FAIL,
  DELETE_CIVILBUDGET,
  DELETE_CIVILBUDGET_SUCCESS,
  DELETE_CIVILBUDGET_FAIL,
  UPDATE_CIVILBUDGET,
  UPDATE_CIVILBUDGET_SUCCESS,
  UPDATE_CIVILBUDGET_FAIL,
  ADD_NEW_CIVILBUDGET,
  ADD_CIVILBUDGET_SUCCESS,
  ADD_CIVILBUDGET_FAIL,
  CIVILBUDGET_LOADING,
  CIVILBUDGET_RESET
} from "./actionType";

export const resetCivilBudgetState = (actionType) => ({
  type: CIVILBUDGET_RESET,
  payload: { actionType },
});

export const getCivilBudgetSuccess = (actionType, data) => ({
  type: GET_CIVILBUDGET_SUCCESS,
  payload: { actionType, data },
});

export const getCivilBudgetFail = (actionType, error) => ({
  type: GET_CIVILBUDGET_FAIL,
  payload: { actionType, error },
});

export const getCivilBudget = data => ({
  type: GET_CIVILBUDGET,
  payload: data,
});

export const getCivilBudgetLoading = () => ({
  type: CIVILBUDGET_LOADING
});

export const deleteCivilBudget = data => ({
  type: DELETE_CIVILBUDGET,
  payload: data,
});

export const deleteCivilBudgetSuccess = data => ({
  type: DELETE_CIVILBUDGET_SUCCESS,
  payload: data,
});

export const deleteCivilBudgetFail = error => ({
  type: DELETE_CIVILBUDGET_FAIL,
  payload: error,
});

export const updateCivilBudget = data => ({
  type: UPDATE_CIVILBUDGET,
  payload: data,
});

export const updateCivilBudgetFail = error => ({
  type: UPDATE_CIVILBUDGET_FAIL,
  payload: error,
});

export const updateCivilBudgetSuccess = data => ({
  type: UPDATE_CIVILBUDGET_SUCCESS,
  payload: data,
});

export const addNewCivilBudget = data => ({
  type: ADD_NEW_CIVILBUDGET,
  payload: data,
});

export const addCivilBudgetSuccess = data => ({
  type: ADD_CIVILBUDGET_SUCCESS,
  payload: data,
});

export const addCivilBudgetFail = error => ({
  type: ADD_CIVILBUDGET_FAIL,
  payload: error,
});